import { useRestMutation } from 'utils/hooks/api/useRestMutation';

type SubmitAdAccountRequest = {
  adAccountIds: string;
};

const SUBMIT_AD_ACCOUNT_URL = '/integrations/submitAdAccounts';

export const useSubmitAdAccounts = () => {
  const { mutate, isLoading, isError, isSuccess } = useRestMutation<
    unknown,
    SubmitAdAccountRequest
  >(SUBMIT_AD_ACCOUNT_URL);

  const submit = (adAccountIds: string) => mutate({ adAccountIds });

  return {
    submit,
    isLoading,
    isError,
    isSuccess,
  };
};
